<template>
  <div class="lp-shape-toolbar" v-if="value">
    <template v-if="!changeContentProtection">
      <template v-if="fill">
        <v-icon small class="ml-2 mr-3">mdi-format-color-fill</v-icon>
        <div class="lp-shape-toolbar-color mr-4">
          <preset-input-color
            :value="value.data.style.fill"
            @input="value.data.style.fill = $event"
            :small="true"></preset-input-color>
        </div>
      </template>
      <v-icon small class="ml-2 mr-3">mdi-border-outside</v-icon>
      <div class="lp-shape-toolbar-color">
        <preset-input-color
          :value="value.data.style.stroke"
          @input="value.data.style.stroke = $event"
          :small="true"></preset-input-color>
      </div>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn flat v-on="on">
            <v-icon small>mdi-format-line-weight</v-icon>
            <v-icon small>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-text class="lp-shape-toolbar__slider">
            <v-slider
              v-model="value.data.style.strokeWidth"
              thumb-label="always"
              thumb-size="28"
              hide-details
              :min="0"
              :max="50"></v-slider>
          </v-card-text>
        </v-card>
      </v-menu>
      <v-text-field
        label="Arrowhead Size"
        :value="slope"
        @input="handleInputSlope"
        @keypress="checkOnlyNumbers"
        suffix="px"
        hide-details
        style="width: 11rem; margin-right: 1rem"
      >
        <template v-slot:append-outer>
          <v-icon @click="updateSlope(-1)">mdi-minus</v-icon>
          <v-icon @click="updateSlope(1)">mdi-plus</v-icon>
        </template>
      </v-text-field>

      <v-text-field
        label="Thickness"
        :value="thickBody"
        @input="handleInputThickBody"
        @keypress="checkOnlyNumbers"
        suffix="px"
        hide-details
        style="width: 11rem"
      >
        <template v-slot:append-outer>
          <v-icon @click="updateThickBody(-1)">mdi-minus</v-icon>
          <v-icon @click="updateThickBody(1)">mdi-plus</v-icon>
        </template>
      </v-text-field>
    </template>
    <div v-else style="color: #7d7d7d">
      <v-icon small class="ml-2 mr-3">mdi-lock-outline</v-icon>
      Change content protection enabled
    </div>
  </div>
</template>

<script>
import PresetInputColor from "../../components/slides/styles/PresetInputColor"
import { PToolbarAction } from "plant-common"
export default {
  name: "ShapeToolbar",
  props: {
    value: {
      default: null
    },
    fill: {
      default: true
    }
  },
  data() {
    return {
      slope: 0,
      thickBody: 0
    }
  },
  components: {
    PresetInputColor,
    PToolbarAction
  },
  methods: {
    handleInputSlope(value) {
      const slopePx = this.width - value
      this.value.data.controls.slope = slopePx / this.width
    },
    updateSlope(delta) {
      const slopePx = this.value.data.controls.slope * this.width
      const distanceFromRight = this.width - slopePx

      let newDistanceFromRight = distanceFromRight + delta
      newDistanceFromRight = Math.max(newDistanceFromRight, 0)

      const newSlopePercentage = (this.width - newDistanceFromRight) / this.width

      this.value.data.controls.slope = newSlopePercentage
    },
    handleInputThickBody(value) {
      this.value.data.controls.thickBody = value / this.width
    },
    updateThickBody(delta) {
      const thickBodyPx = this.value.data.controls.thickBody * this.width

      const newThickBodyPercentage = (thickBodyPx + delta) / this.width

      this.value.data.controls.thickBody = newThickBodyPercentage
    },
    checkOnlyNumbers(event) {
      const isNumber = /[0-9]/.test(event.key)
      const isValidKey = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Enter'].includes(event.key)
      
      if (!isNumber && !isValidKey) event.preventDefault()
    }
  },
  computed: {
    changeContentProtection() {
      return this.value.protection.data
    },
    width() {
      return this.value.size.width
    }
  },
  watch: {
    'value.data.controls.slope': {
      immediate: true,
      handler(value) {
        if (!this.value) return

        const slopePx = value * this.width
        const distanceFromRight = this.width - slopePx

        this.slope = Math.round(distanceFromRight)
      }
    },
    'value.data.controls.thickBody': {
      immediate: true,
      handler(value) {
        if (!this.value) return

        const thickBodyPx = value * this.width

        this.thickBody = Math.round(thickBodyPx)
      }
    }
  }
}
</script>

<style>
.lp-shape-toolbar,
.lp-shape-toolbar-color {
  display: flex;
}

.lp-shape-toolbar-color {
  align-items: center;
}

.v-card .v-card__text.lp-shape-toolbar__slider {
  padding: 28px 20px 10px;
}
</style>
